import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

const LoginPage = () => {
    useEffect(() => {
        // Open login modal when directly accessing this page
        document.dispatchEvent(new CustomEvent('open-login-modal'));
    }, []);

    return <Navigate to="/" replace />;
};

export default LoginPage; 